survey.vue<template>
  <div class="userIdx">
    <div class="main">
      <div class="lft">
        <div class="headTitle">
          配置信息
        </div>
        <el-menu
          :default-active="$route.path"
          class="el-menu-vertical-demo"
          :collapse="isCollapse"
          :unique-opened="false"
          background-color="#FFF"
          text-color="#000"
          active-text-color="#1C6AFF"
          router
        >
          <!-- <el-menu-item index="/configuration/weChat">
            <span slot="title">微信配置</span>
          </el-menu-item>
          <el-menu-item index="/configuration/wxConfigIndex">
            <span slot="title">公众号配置</span>
          </el-menu-item> -->
          <el-menu-item index="/configuration/subScription/home">
            <!-- <i class="el-icon-menu"></i> -->
            <span slot="title">公众号管理</span>
          </el-menu-item>
          <el-menu-item index="/configuration/miniApp/index">
            <span slot="title">小程序管理</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="rgt">
        <div class="rgt-header">
          <div class="alignAt">
            <span v-html="crumbsCont"></span>
          </div>
        </div>
        <div class="cont">
          <transition name="el-fade-in">
            <router-view></router-view>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "userIdx",
  computed: {
    ...mapGetters(["crumbsCont", "token"])
  },
  data() {
    return {
      show: true,
      isCollapse: false
    };
  },
  methods: {
    ...mapMutations(["SET_TOKEN", "SET_APPID"]),
    change() {
      this.isCollapse = !this.isCollapse;
    }
  }
};
</script>

<style lang="scss" scoped>
.userIdx {
  height: 100%;
  position: relative;
  i {
    color: #fff;
  }
  .main {
    position: absolute;
    top: 0px;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: row;
    .lft {
      height: 100%;
      background: #ffffff;
      overflow: hidden;
      border-right: 1px solid rgb(223, 223, 223);
      .headTitle {
        font-size: 14px;
        height: 50px;
        line-height: 50px;
        padding-left: 20px;
        border-bottom: 1px solid rgb(223, 223, 223);
      }
      .el-menu {
        border: 0;
      }
      .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 160px;
        min-height: 400px;
      }
    }
    .rgt {
      flex: 1;
      position: relative;
      background: #f7f8fa;
      .cont {
        position: absolute;
        top: 50px;
        bottom: 0;
        width: 100%;
        min-width: 900px;
        overflow: auto;
      }
      .rgt-header {
        height: 50px;
        text-align: left;
        background: #fff;
        // -webkit-box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
        box-shadow: 1px 2px 4px rgba(0, 21, 41, 0.08);
        line-height: 50px;
        font-size: 14px;
        padding-left: 24px;
        // border-bottom: 1px solid rgb(223, 223, 223);
        .alignAt {
          display: flex;
          flex-direction: row;
          align-items: center;
        }
        .el-icon-menu {
          font-size: 18px;
          color: #999;
          margin-right: 10px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.userIdx {
  .el-menu-item-group__title {
    padding: 0;
  }
  .el-submenu__title {
    height: 40px;
    line-height: 40px;
  }
  .el-menu-item {
    height: 40px;
    line-height: 40px;
  }
}
</style>
